import { DefaultNotification } from "./DefaultNotification";
import {NotificationTypes} from "./NotificationTypes";
import {getSiteDetail} from "../layout/SetPageTitle";

export class DefaultError extends DefaultNotification {
    constructor(notificationAdapter) {
	    const message = `There was an error while attempting to contact the server. If the problem persists, contact ${getSiteDetail().SupportEmail}.`;
	    super(notificationAdapter, NotificationTypes.ERROR, message);
    }
}